import { ref, watch, computed } from '@vue/composition-api';
import { TABLE, MAS_LIST } from '@/constants/config';
import { pluck } from '@/helpers';

export default function useDirectorInterestsTable() {
    const refComplianceTable = ref(null);

    const perPage = ref(TABLE.PER_PAGE);
    const totalCompliance = ref(0);
    const currentPage = ref(1);
    const perPageOptions = TABLE.PER_PAGE_OPTIONS;
    const searchQuery = ref('');
    const sortBy = ref('id');
    const isSortDirDesc = ref(true);
    const isBusy = ref(false);
    const isLoading = ref(false);
    const tableColumns = ref([]);

    // table default vertical align middle, we can change it by giving td class `align-top`
    tableColumns.value = [
        { key: 'index', label: '#', thClass: 'px-1 text-nowrap', tdClass: 'px-1 index text-nowrap align-top' },
        { key: 'category', label: 'CATEGORY', sortable: true, thClass: 'px-1', tdClass:'py-1 px-1 align-top'},
        { key: 'regulations', label: 'REGULATIONS/LEGISLATION ', thClass: 'px-1', sortable: true, tdClass:'py-1 px-1 align-top'},
        { key: 'lastUpdated', label: 'LAST UPDATED', thClass: 'px-1 text-nowrap', tdClass:'py-1 px-1 text-nowrap align-top'},
        { key: 'status', label: 'STATUS', thClass: 'px-1', tdClass:'py-1 px-1 align-top'},
        { key: 'actions', label: 'ACTION', thClass: 'pl-0 pr-1 text-right', tdClass: 'px-0 pr-1 text-right align-top' },
    ];
    
    const filterOn = ref([
        'regulations',
        'category'
    ]);

    const dataMeta = computed(() => {
        const localItemsCount = refComplianceTable.value ? refComplianceTable.value.localItems.length : 0;
        totalCompliance.value = localItemsCount;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalCompliance.value,
        };
    });

    const refetchData = () => {
        refComplianceTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
        refetchData();
        const queryLowered = searchQuery.value.toLowerCase().trim();
        
        //  if a query present then search
        if (queryLowered)
        {
            refComplianceTable.value.localItems= refComplianceTable.value.localItems.filter(item => filterOn.value.some(key => {
                const value = pluck(key, item);
                
                return value && value.toString().toLowerCase().trim().includes(queryLowered);
            }));
        }
        isBusy.value = false;
    });

    const resolveMasListStatusVariant = status => {
        if (status === MAS_LIST.STATUS_IMPORTING) return 'primary';
        if (status === MAS_LIST.STATUS_IMPORTED) return 'success';
        if (status === MAS_LIST.STATUS_EXCEPTION_OCCURRED) return 'danger';
        return 'primary';
    };

    return {
        sortBy,
        isBusy,
        perPage,
        dataMeta,
        isLoading,
        searchQuery,
        currentPage,
        isSortDirDesc,
        totalCompliance,
        perPageOptions,
        refComplianceTable,
        resolveMasListStatusVariant,

        refetchData,
        tableColumns,
        filterOn,
    };
}
